<script lang="ts" setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const emits = defineEmits<{
    'input': [ev: Event, value: string];
    'change': [ev: Event, value: string];
    'update:modelValue': [value: string];
}>();

const props = defineProps({
    placeholder: {
        type: String,
        default: ''
    },
    modelValue: {
        type: String,
        default: ''
    },
    enableIcon: {
        type: Boolean,
        default: true
    },
    autofocus: {
        type: Boolean,
        default: false
    }
});

function onInput(ev: Event): void {
    let value = (ev.target as HTMLInputElement | undefined)?.value;

    value ??= '';

    emits('update:modelValue', value);
    emits('input', ev, value);
}

function onChange(ev: Event): void {
    let value = (ev.target as HTMLInputElement | undefined)?.value;

    value ??= '';

    emits('update:modelValue', value);
    emits('change', ev, value);
}

const placeholderText = computed(() => (props.placeholder !== '' ? props.placeholder : t('system.search')));
</script>

<template>
    <!-- Search box -->
    <div class="flex-container align-middle sy-bg-white padding-horizontal-5 sy-border sy-rounded-2">
        <Icon
            v-if="enableIcon"
            class="sy-icon-gray sy-icon-medium"
            icon="search"
            data-test="search-bar-icon"
        />
        <input
            v-focus="autofocus"
            type="search"
            :value="modelValue"
            class="sy-input-native padding-right-0 border-none"
            :placeholder="placeholderText"
            data-test="search-bar-input"
            @input="onInput"
            @change="onChange"
            @keypress.enter="onChange"
        />
    </div>
</template>
<style lang="scss">
.sy-input-native {
    border: none;

    &:focus {
        border: none;
    }
}
</style>
